import { getAccountScopeUserSettings } from 'owa-session-store';
import { updateAccountScopeUserSettingsAndService } from 'owa-userconfiguration/lib/utils/updateAccountScopeUserSettingsAndService';
import type { MailboxInfo } from 'owa-client-types';
export type ListViewBitFlagsMasks = any;

/**
 * Gets a boolean to indicate if the n th bit is 1
 * @param bitMask represents the nth bit
 * @return true if nth bit is 1, false if 0
 */
export function getIsBitSet(bitMask: ListViewBitFlagsMasks, mailboxInfo: MailboxInfo): boolean {
    const listViewBitFlags =
        getAccountScopeUserSettings(mailboxInfo)?.ViewStateConfiguration?.ListViewBitFlags || 0;

    return !!(bitMask & listViewBitFlags);
}

/**
 * Set bit flag
 * @param value set to 1 if true, 0 otherwise
 * @param bitMask represents the nth bit
 */
export async function setBitAndUpdateAccountScopeUserSettingsAndService(
    value: boolean,
    bitMask: ListViewBitFlagsMasks,
    mailboxInfo: MailboxInfo
): Promise<void>;
export async function setBitAndUpdateAccountScopeUserSettingsAndService(
    updates: ListViewBitFlagUpdate[],
    mailboxInfo: MailboxInfo
): Promise<void>;
export async function setBitAndUpdateAccountScopeUserSettingsAndService(
    valueOrUpdates: boolean | ListViewBitFlagUpdate[],
    bitMaskOrMailboxInfo: ListViewBitFlagsMasks | MailboxInfo,
    mailboxInfoMaybe?: MailboxInfo
): Promise<void> {
    const updates: ListViewBitFlagUpdate[] = Array.isArray(valueOrUpdates)
        ? valueOrUpdates
        : [{ value: valueOrUpdates, bitMask: bitMaskOrMailboxInfo as ListViewBitFlagsMasks }];
    const mailboxInfo = Array.isArray(valueOrUpdates)
        ? (bitMaskOrMailboxInfo as MailboxInfo)
        : mailboxInfoMaybe;

    if (!mailboxInfo || updates.length === 0) {
        return;
    }

    const listViewBitFlags =
        getAccountScopeUserSettings(mailboxInfo)?.ViewStateConfiguration?.ListViewBitFlags || 0;

    let newValue: number = listViewBitFlags;

    for (const update of updates) {
        newValue = update.value ? newValue | update.bitMask : newValue & ~update.bitMask;
    }

    if (newValue === listViewBitFlags) {
        return;
    }

    await updateAccountScopeUserSettingsAndService(mailboxInfo, {
        ViewStateConfiguration: {
            ListViewBitFlags: newValue,
        },
    });
}

/**
 * Set multiple bit flags in a single update.
 * @param updates list of bit updates where value=true sets the bit and value=false clears it
 */
export async function setBitsAndUpdateAccountScopeUserSettingsAndService(
    updates: ListViewBitFlagUpdate[],
    mailboxInfo: MailboxInfo
): Promise<void> {
    await setBitAndUpdateAccountScopeUserSettingsAndService(updates, mailboxInfo);
}

/**
 * @deprecated Use overloads on setBitAndUpdateAccountScopeUserSettingsAndService or use setBitsAndUpdateAccountScopeUserSettingsAndService.
 */
export async function setBitAndUpdateAccountScopeUserSettingsAndServiceSingle(
    value: boolean,
    bitMask: ListViewBitFlagsMasks,
    mailboxInfo: MailboxInfo
): Promise<void> {
    await setBitAndUpdateAccountScopeUserSettingsAndService(value, bitMask, mailboxInfo);
}

export type ListViewBitFlagUpdate = {
    value: boolean;
    bitMask: ListViewBitFlagsMasks;
};
